import React, { useRef, useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import VideoPlayer from '../Camera/VideoPlayer';

const SlotBookings = ({ open, onClose, initiateMarkings, completeMarkings,streamUrl}) => {
  const [polygons, setPolygons] = useState([]);
  const [currentPoints, setCurrentPoints] = useState([]);
  const [isMarking, setIsMarking] = useState(false);
  const [loading, setLoading] = useState(false);
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const videoRef = useRef(null);

  const handleCanvasClick = (e) => {
    if (!isMarking) return;
    // if (polygons?.length === 0 || !polygons) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const newPoints = [...currentPoints, { x, y }];

    if (newPoints.length === 4) {
      setPolygons((prev) => [...prev, newPoints]);
      setCurrentPoints([]);
    } else {
      setCurrentPoints(newPoints);
    }
  };

  const drawPolygons = () => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');
    if (!canvas || !ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // if (polygons?.length === 0 || !polygons) return;
    [...polygons, currentPoints].forEach((polygon) => {
      if (polygon.length === 0) return;

      ctx.beginPath();
      ctx.moveTo(polygon[0].x, polygon[0].y);
      polygon.slice(1).forEach((pt) => ctx.lineTo(pt.x, pt.y));
      if (polygon.length === 4) ctx.closePath();

      ctx.strokeStyle = 'red';
      ctx.lineWidth = 2;
      ctx.stroke();

      polygon.forEach(({ x, y }) => {
        ctx.beginPath();
        ctx.arc(x, y, 4, 0, 2 * Math.PI);
        ctx.fillStyle = 'blue';
        ctx.fill();
      });
    });
  };

  useEffect(() => {
    drawPolygons();
  }, [polygons, currentPoints]);
  
  useEffect(() => {
    if (open) {
      setPolygons([]);
      setCurrentPoints([]);
      setIsMarking(false);
      const video = videoRef.current;
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }
  }, [open]);
  const handleSave = async () => {
    console.log('Saved Polygons:', polygons);
    // alert('Saved! Check console.');
    setLoading(true);
    await completeMarkings(polygons);
    setLoading(false);
    onClose();
  };

  const handleUndo = () => {
    setPolygons((prev) => prev.slice(0, -1));
  };

  const makeMarking = async ()=>{
    if(isMarking){
      setIsMarking(false);
    }
    else{
      await initiateMarkings();
      setIsMarking(true);
    }
  }
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Mark Slots</DialogTitle>
      <DialogContent 
     >
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" >
        <Box
          ref={containerRef}
          style={{
            position: 'relative',
            width: '640px',
            height: '475px',
            marginBottom: 16,
          }}
        >
          <VideoPlayer src={streamUrl} />
          <canvas
            ref={canvasRef}
            width={640}
            height={475}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              pointerEvents: isMarking ? 'auto' : 'none',
              cursor: isMarking ? 'crosshair' : 'default',
            }}
            onClick={handleCanvasClick}
          />
        </Box>

          <Box display="flex" flexWrap="wrap" justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
            <Box sx={{ m: 1 }}>
              <Button variant="outlined" color="secondary" onClick={handleUndo}>
                Remove Last Slot
              </Button>
            </Box>


            <Box sx={{ m: 1 }}>
              <Button
                variant="contained"
                color={isMarking ? 'secondary' : 'primary'}
                onClick={makeMarking}
              >
                {isMarking ? 'Cancel Marking' : 'Mark Slots'}
              </Button>
            </Box>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions style={{ padding: 15 }}>
        <Button onClick={onClose} color="default" variant="outlined">
          Cancel
        </Button>
        {
          polygons?.length > 0 && 
          <Button onClick={handleSave} color="primary" variant="contained">
            Save Coordinates
          </Button>
        }
      </DialogActions>
    </Dialog>
  );
};

export default SlotBookings;
